module.exports = __webpack_public_path__ + "static/media/dstv.d0559917.svg";